<template lang="pug">
  .container
    .columns.has-text-centered
      .column.is-2(v-if="consumible.subcategoria=''")
        span.tag.is-black {{ consumible.categoria }}
      .column.is-2(v-else)
        .tags.has-addons
          span.tag.is-black {{ consumible.categoria }}
          span.tag.is-light {{ consumible.subcategoria }}
      .column.is-2.is-vcentered
        .tags.has-addons
          span.is-size-6 Marca:&nbsp
          span.is-size-6
            b  {{ consumible.marca }}
      .column.is-2
          span.is-size-6 Modelo: 
          span.is-size-6 
            b {{ consumible.modelo }}
      .column.is-2
          span.is-size-6 Stock:&nbsp
          span.tag.is-black
            | {{ consumible.stock }}
      .column.is-2
          span.is-size-6 Límite:&nbsp
          span.tag.is-danger
            | {{ consumible.limite }}
</template>

<script>
  export default {
    name: 'CardConsumibleDetalle',
    props: {
      consumible: {
        type: Object,
        default: () => {}
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/CardConsumibleDetalle.vue